App.module('BbSearchApp.BbSearch', function(BbSearch, App, Backbone, Marionette, $, _){
    'use strict';

    BbSearch.SearchForm = Marionette.ItemView.extend({
        el: '#searchForm, #menuSlidebar',
        template: false,
        defaultSearchSize: 6,
        ui: {
            searchBlock: '#searchResultsDesktop',
            searchText: '.searchFormFieldText',
            searchTextContainerClass: '.searchFormFieldText',
            text: '.searchHeader',
            loader: '.searchLoader',
            footerLink: '.searchFooter',
            searchResultContainer: '.searchFormResultRegion',
            noResultsContainer: '.noResultsHeader',
            clearButton: '#resetBtn',
            goButton: '.goBtn',
            viewAllLink: '.searchResultAllLink',
            iScrollWrapper: '.search-result-wrapper',
            searchLoadingOverlay: '.searchLoadingOverlay'
        },
        events: {
            'keyup @ui.searchText': 'onSearchTermChange',
            'click @ui.clearButton': 'onClearButtonClicked',
            'click @ui.goButton': 'navigateToFullSearch',
            'click @ui.viewAllLink': 'navigateToFullSearch',
            'click @ui.searchResultContainer': 'searchDropDownClicked',
            'focusin @ui.searchText': 'showSearchUI',
            'blur @ui.searchText': '_checkInputValue',
            'customFocusout @ui.searchText': 'hideSearchBlock' // AODA
        },
        placeholderClass: 'withPlaceholder',
        hiddenButtonsClass: 'hiddenButtons',
        focusClass: 'focused',
        initialize: function(){
            this.bindUIElements();
            App.on('bbsearch:started', _.bind(this.onSearchStarted, this));
            App.on('bbsearch:finished', _.bind(this.displayResult, this));
            App.on('bbsearch:checkResponse', _.bind(this.checkSearchResponse, this));
            App.on("bbsearch:error", _.bind(this.displayNoResult, this));
            App.on("bbsearch:noResult", _.bind(this.displayNoResult, this));
            App.on("bbsearch:clear_results", _.bind(this.hideSearchBlock, this));
            App.on("bbsearch:initialize", _.bind(this.initializeSearch, this));
            App.on('bbsearch:page:term', _.bind(this.hideSearchBlock, this));
            App.on('bbsearch:page:start', _.bind(this.startSearchPage, this));
            App.on('bbsearch:search:onBeforeNavigateToFullSearch', function(evStatus) {
                evStatus.ready = window.VHR_SAVE_CHANGES ? false : true;
            });

            this.viewAllLink = this.ui.viewAllLink.attr('href');
            this.bindEvents();
            this.refreshClearButtonView();
        },
        bindEvents: function () {
              function closeOnClickOutOfActualDom (e) {
                if (this.$el && !this.$el.is(e.target) && this.$el.has(e.target).length === 0) {
                  this.removeFocus();
                  this.hideSearchBlock();
                }
              }
            $(document).click(closeOnClickOutOfActualDom.bind(this));

            $(this.ui.searchText).typeahead({
                hint: true,
                highlight: true,
                minLength: 1
            },
            {
                name: 'states',
                displayKey: 'term',
                source: this.getTypeaheadList
            });

          this.$el.refineFormPlaceholders();
        },
        _checkSearchVersion: function() {
            return this.$el.hasClass('searchForm_V2');
        },
        _getInputValue: function($el) {
            return $el.hasClass(this.placeholderClass) ? '' : $el.val()
        },
        initializeSearch: function(searchTerm) {
            this.ui.searchText.val(searchTerm);
            this.ui.viewAllLink.attr('href', this.viewAllLink + '#search/' + searchTerm);
            this.refreshClearButtonView();
            if (searchTerm && ! App.BbSearchApp.isSearchPage) {
              this.addFocus();
            }
        },
        searchDropDownClicked: function(){
        },
        hideSearchUI: function(){
            this.displayLoader(true);
            this.ui.loader.toggle(false);
        },
        showSearchUI: function(e){
            this.addFocus();
            var target = $(e.target),
                value = this._getInputValue(target);

            if(App.BbSearchApp.isSearchPage && App.BbSearchApp.searchPhrase === value){
                return;
            }

            if($.trim(value) !== '') {

                if(this._checkSearchVersion() && ! this.ui.searchBlock.is(':visible')) {
                    this.$el.on('transitionend', function(){
                      this.displayLoader(false);

                      if (!this.hasData) {
                        this.displayNoResult();
                      }

                      this.$el.off('transitionend');
                    }.bind(this));
                } else {
                    this.displayLoader(false);
                  if (!this.hasData) {
                    this.displayNoResult();
                  }
                }
            }
        },
      _checkInputValue: function(e) {
          var value = this._getInputValue($(e.target));
          if (value.trim() === '') {
            this.removeFocus();
          }
      },
      addFocus: function() {
        this.$el.addClass(this.focusClass);
      },
      removeFocus: function() {
        this.$el.removeClass(this.focusClass);
      },
        onSearchTermChange : function(e){
            if (e.keyCode === 13) {
                if(!App.BbSearchApp.isSearchPage) {
                    this.navigateToFullSearch(e);
                } else {
                    App.trigger('bbsearch:break:search');
                    this.onSearchStarted();
                }
                return;
            }

            if (e.keyCode === 27) {
                this.hideSearchUI();
                return;
            }
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }

            var view = this;
            var target = $(e.target),
                targetValue = this._getInputValue(target);

            view.sendSearchTerm(targetValue);
            this.ui.searchTextContainerClass.not(':visible').val(targetValue);

            ga('send','event','Search Bar', 'search', targetValue);

            this.refreshClearButtonView();
        },
        onClearButtonClicked: function(e){
            if(e) {
                e.preventDefault();
            }

            this.ui.searchText.val('');
            this.clearSearchResult();
            this.refreshClearButtonView();
            this.hideSearchBlock();
            App.navigate('search');
        },
        navigateToFullSearch: function(e){
            e.preventDefault();

            // TVGUSA-44634
            var evStatus = {ready: true};
            App.trigger('bbsearch:search:onBeforeNavigateToFullSearch', evStatus);
            if (!evStatus.ready) {
                return;
            }

            if(!App.BbSearchApp.isSearchPage) {
                if ($.trim($(this.ui.searchText).filter(':visible').val())) {
                    window.location = this.ui.viewAllLink.attr('href');
                }
            } else {
                App.trigger('bbsearch:break:search');
                App.trigger('bbsearch:page:term', $.trim($(this.ui.searchText).filter(':visible').val()));
                this.removeFocus();
            }
        },
        refreshClearButtonView: function(){

            if(this.ui.searchText.length) {
                var $searchText = $(this.ui.searchText).filter(':visible');
                if($searchText.length) {
                    this.ui.clearButton.toggle(this.getSearchFieldValue($searchText) !== '');
                    this.ui.goButton.toggle(this.getSearchFieldValue($searchText) !== '');
                    this.$el.toggleClass(this.hiddenButtonsClass, this.getSearchFieldValue($searchText) !== '');
                }
            }
        },
        getSearchFieldValue: function ($el) {
            $el = $el && $el.length ? $el : this.ui.searchText;

            if($.fn.isIE()) {
                return $el.val().trim() == '' || ($el.val().trim() == $el.attr('placeholder')) ? '' : $el.val().trim();
            }

            return $el.val().trim();
        },
        sendSearchTerm : function(searchTerm){
            App.trigger('bbsearch:term', searchTerm);
            this.refreshClearButtonView();
            this.ui.viewAllLink.attr('href', this.viewAllLink + '#search/' + searchTerm);
        },
        displayLoader: function(bool){
            this.ui.searchBlock.toggle(! bool);
            this.ui.text.toggle(! bool);
            this.ui.footerLink.toggle(! bool);
            this.ui.searchResultContainer.toggle(! bool);

            this.ui.loader.toggle(bool);
            this.ui.noResultsContainer.toggle(false);
            if(bool) {
              this.ui.searchBlock.addClass('searchLoadingOverlay');
            } else {

              this.ui.searchBlock.removeClass('searchLoadingOverlay');
            }
        },
        displayResult: function(model) {
            var self = this;
            var collectionView = new BbSearch.SearchResults({collection: model});
            var collectionViewMobile = new BbSearch.SearchResults({collection: model});
            if (! this.region){
                this.region = new Backbone.Marionette.Region({ el: '#searchResultsRegion'});
                this.region.on('show', function() {
                    self.setTabindex();
                });
            } else {
                this.region.reset();
                this.ui.iScrollWrapper.hide();
            }
            if (! this.regionMobile){
                this.regionMobile = new Backbone.Marionette.Region({ el: '#searchResultsRegionMobile'});
                this.regionMobile.on('show', function() {
                    self.setTabindex();
                });
            } else {
                this.regionMobile.reset();
            }
            this.region.show(collectionView);
            this.regionMobile.show(collectionViewMobile);

            collectionView.on('childview:resultView:choose', function() {
                self.hideSearchBlock();
            });

            this.renderIScroll();

            this.displayLoader(false);

            if(!this.hasData){
                this.displayNoResult();
            }

        },
        setTabindex: function() {
            var self = this;

            self.ui.searchText.trigger('content.updated'); // AODA
            self.$el.find('a').each(function() {
                if(!$(this).text()) {
                    $(this).attr('tabindex', '-1');
                }
            });
            self.$el.find('a').on('keydown', function(e) {
                if(e.keyCode === 13) {
                    if($(this).attr('href')) {
                        window.location.href = $(this).attr('href');
                    }

                    return false;
                }

            });
        },
        renderIScroll: function()
        {
            if (this.iScroll) {
                this.iScroll.destroy();
                this.iScroll = null;
            }

            this.ui.iScrollWrapper.show();

            this.iScroll = new IScroll('.search-result-wrapper', {
                scrollbars: true,
                mouseWheel: true,
                interactiveScrollbars: true,
                fadeScrollbars: false,
                bounce: false,
                click: true
            });
        },
        onSearchStarted: function(){
          this.displayLoader(true);
        },
        displayNoResult: function(){
            this.displayLoader(false);

            this.ui.text.toggle(false);
            this.ui.noResultsContainer.toggle(true);
            this.ui.footerLink.toggle(true);
            this.ui.searchResultContainer.toggle(false);
            this.ui.loader.toggle(false);
        },
        hideSearchBlock: function() {
            this.ui.searchBlock.hide();
        },
        showSearchBlock: function() {
            this.ui.searchBlock.show();
        },
        clearSearchResult: function() {
            this.region && this.region.reset();
            this.regionMobile && this.regionMobile.reset();
            this.ui.iScrollWrapper.hide();
        },
        checkSearchResponse: function(results) {
            var typeaheadRawList = results.suggest.term;
            var lastPossibleAdvice;
            this.typeaheadList = [];
            if (typeaheadRawList.length) {
                lastPossibleAdvice = typeaheadRawList.pop();
                if (lastPossibleAdvice.options && lastPossibleAdvice.options.length) {
                    lastPossibleAdvice.options.forEach(function(record){
                        this.typeaheadList.push({
                            term: record.text
                        });
                    }, this);
                }
            }
            this.hasData = results.hits.hits.length > 0;
            self.typeaheadListRequestDfd && self.typeaheadListRequestDfd.resolve(this.typeaheadList);
        },
        getTypeaheadList: function (query, process) {
            self.typeaheadListRequestDfd = new $.Deferred();
            self.typeaheadListRequestDfd.promise().then(function(data) {
                return process(data);
            });

            return self.typeaheadListRequestDfd;
        },
        startSearchPage: function(searchPhrase) {
            this.ui.searchText.val(searchPhrase);
            this.refreshClearButtonView();
        }

    });

    // >>> Search results
    BbSearch.SearchResult = Marionette.ItemView.extend({
        template: '#search-res-temp',
        tagName: 'li',
        className: 'searchResultListRow',
        ui: {
            link: 'a'
        },
        events: {
            'click @ui.link': 'closeSearchResults'
        },
        initialize: function() {
            this.bindUIElements();
            this.listenTo(this.model, 'externalFocus', this.onFocus);
        },
        closeSearchResults: function(e) {
            this.trigger('resultView:choose');
            ga('send','event','Search Bar', 'click result', e.currentTarget.href);
        },
        onFocus: function() {
            this.ui.link.eq(0).focus();
        }
    });

    BbSearch.SearchResults = Marionette.CollectionView.extend({
        tagName: 'ul',
        className: 'searchResultList',
        childView: BbSearch.SearchResult
    });


});
